import type { Settlement } from '../engine/map/settlement';
import { getGameConfig } from '../config/gameConfig';

export function runTreeTick(settlement: Settlement): boolean {
    const { tree } = getGameConfig();
    let changed = false;

    settlement.production.ecology.treeTick += 1;
    settlement.production.ecology.reseedTick += 1;

    if (settlement.production.ecology.treeTick >= tree.ageInterval) {
        settlement.production.ecology.treeTick = 0;
        if (settlement.regionResources.trees.length > 0) {
            settlement.regionResources.trees.forEach((entry) => {
                entry.age = Math.min(entry.age + 1, tree.maxAge);
            });
            changed = true;
        }
    }

    if (settlement.production.ecology.reseedTick >= tree.reseedInterval) {
        settlement.production.ecology.reseedTick = 0;
        const cap = settlement.regionResources.canopyCap;
        if (cap > 0) {
            const total = settlement.regionResources.trees.reduce(
                (sum, entry) => sum + entry.amount,
                0,
            );
            if (total < cap * tree.reseedThreshold) {
                const add = Math.floor((cap - total) * tree.reseedRate);
                if (add > 0) {
                    const bucket = settlement.regionResources.trees.find(
                        (entry) => entry.age === 0,
                    );
                    if (bucket) bucket.amount += add;
                    else settlement.regionResources.trees.push({ age: 0, amount: add });
                    changed = true;
                }
            }
        }
    }

    return changed;
}
